import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
const recap = ['6 dílů', '5 bonusů', '240 stran', '1.–9. ročník'];
const reassurances = ['Okamžité digitální stažení', 'PDF připravené k tisku', '7denní garance spokojenosti'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15bsormn3uimq">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbk9e684mx9p" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1ec7ldi5irk5j">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t1n0u1zlo35x">
          Vaše hodiny tělocviku mohou být <em className="text-red-700" data-id="element-118" data-mp="1o67pphsz8ld7">připravené už dnes.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="223w6adg0h6cg">
          Místo hledání her na internetu, kreslení každého nákresu a nedělních večerů nad přípravami máte přehledný balíček tělesné výchovy na celý školní rok. Víc času na to, na čem opravdu záleží:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="s4xozgr5njm3">
          Vaši žáci. Vaše výuka. Váš život mimo školu.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="123wp2axuu6xh">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1646w7qxdv3dx">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b31pxnww2cct">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1fvb82hrri84j">Jednorázová platba – žádné předplatné.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1ksbeitsixcw6">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1kv7bofwjrxjk" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1pu0soib1m6oh">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="1tropxs07kbjj">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3qvgpnwhf0bax" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}